import React from 'react';
import Header, { HeaderLeft } from '../../../layout/Header/Header';
import CommonHeaderRight from './CommonHeaderRight';

const RequestedFeaturedCenterManagementHeader = () => {
	return (
		<Header>
			<HeaderLeft className='h4 mb-0 fw-bold'>Feature Center Requests</HeaderLeft>
			<CommonHeaderRight />
		</Header>
	);
};

export default RequestedFeaturedCenterManagementHeader;
